import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import toast from 'react-hot-toast'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

interface SendMessageParams {
  profileId: string
  content: string
}

export const useSendMessageToMatch = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: SendMessageParams) => {
      const response = await fetchWithAuth(
        `${URL}/profiles/${params.profileId}/message`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message_text: params.content,
          }),
        }
      )
      return response
    },
    onSuccess: (data, variables) => {
      // Invalidate relevant queries
      queryClient.invalidateQueries({
        queryKey: ['messages'],
      })
      toast.success('Message sent successfully')
    },
    onError: (error) => {
      console.error('Error sending message:', error)
      toast.error('Failed to send message')
    },
  })
}
